import { render } from "./side-nav-inner-toolbar.vue?vue&type=template&id=7b6ccfc6"
import script from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js"
export * from "./side-nav-inner-toolbar.vue?vue&type=script&lang=js"

import "./side-nav-inner-toolbar.vue?vue&type=style&index=0&id=7b6ccfc6&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__